import { render } from "./TopQueuesCard.vue?vue&type=template&id=168a10f6"
import script from "./TopQueuesCard.vue?vue&type=script&lang=js"
export * from "./TopQueuesCard.vue?vue&type=script&lang=js"

import "./TopQueuesCard.vue?vue&type=style&index=0&id=168a10f6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__